import React from "react";
import { severityBadgeColor } from "../utils/vaptConstants";

// Display-only severity label: highlighted text color, no background/
// border/pill container — matches the VaptStatusBadge text treatment.
const VaptSeverityBadge = ({ severity, size = "md" }) => {
  const sizeCls = size === "sm" ? "text-[11px]" : "text-xs";
  return <span className={`font-semibold whitespace-nowrap ${sizeCls} ${severityBadgeColor(severity)}`}>{severity || "Unknown"}</span>;
};

export default VaptSeverityBadge;
